/* AUTO-SYNCED from PsyKit.io/components/session/ScaleInput.tsx — DO NOT EDIT. Regenerate with `npm run sync`. */
"use client";

interface ScaleInputProps {
  value: number | null;
  onChange: (v: number | null) => void;
  label: string;
  min?: number;
  max?: number;
}

export default function ScaleInput({
  value,
  onChange,
  label,
  min = 1,
  max = 10,
}: ScaleInputProps) {
  const steps = Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <div className="flex flex-col gap-2">
      <label
        className="font-[var(--font-barlow)] text-[12px] uppercase tracking-[0.1em]"
        style={{ color: "#A0B8D0" }}
      >
        {label}
      </label>
      <div className="flex gap-1.5">
        {steps.map((step) => (
          <button
            key={step}
            type="button"
            onClick={() => onChange(value === step ? null : step)}
            className="flex-1 py-3 rounded-[4px] font-[var(--font-dm-mono)] text-[15px] font-medium transition-all duration-100"
            style={{
              background: value === step ? "#C9A84C22" : "transparent",
              border: `1px solid ${value === step ? "#C9A84C" : "#3A5270"}`,
              color: value === step ? "#C9A84C" : "#8AABC8",
            }}
            onMouseEnter={(e) => {
              if (value !== step) {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "#5A7A98";
                (e.currentTarget as HTMLButtonElement).style.color = "#B0C8E0";
              }
            }}
            onMouseLeave={(e) => {
              if (value !== step) {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "#3A5270";
                (e.currentTarget as HTMLButtonElement).style.color = "#8AABC8";
              }
            }}
          >
            {step}
          </button>
        ))}
      </div>
    </div>
  );
}
